import { defineComponent as _defineComponent } from 'vue';
import { BFormInput, BInputGroup } from "bootstrap-vue";
import {} from "types/utilityTypes";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'GDateTime',
    props: {
        value: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const date = computed(() => {
            const year = props.value.getFullYear().toString().padStart(4, "0");
            const month = (props.value.getMonth() + 1).toString().padStart(2, "0");
            const day = props.value.getDate().toString().padStart(2, "0");
            return `${year}-${month}-${day}`;
        });
        const time = computed(() => {
            const hours = props.value.getHours().toString().padStart(2, "0");
            const minutes = props.value.getMinutes().toString().padStart(2, "0");
            return `${hours}:${minutes}`;
        });
        function updateDate(newDate) {
            const matches = newDate.match(/(\d{4})-(\d{2})-(\d{2})/);
            if ((matches === null || matches === void 0 ? void 0 : matches.length) && matches.length >= 4) {
                const [_v, year, month, day] = matches;
                const date = new Date(props.value);
                try {
                    date.setFullYear(parseInt(year));
                    date.setDate(1);
                    date.setMonth(0);
                    date.setMonth(parseInt(month) - 1);
                    date.setDate(parseInt(day));
                }
                finally {
                    emit("input", date);
                }
            }
        }
        function updateTime(newTime) {
            const matches = newTime.match(/(\d{2}):(\d{2})/);
            if ((matches === null || matches === void 0 ? void 0 : matches.length) && matches.length >= 3) {
                const [_v, hours, minutes] = matches;
                const date = new Date(props.value);
                try {
                    date.setHours(parseInt(hours), parseInt(minutes));
                }
                finally {
                    emit("input", date);
                }
            }
        }
        return { __sfc: true, props, emit, date, time, updateDate, updateTime, BFormInput, BInputGroup };
    }
});
